<template>
  <div>
    <carousel :topBanner="topBanner" height="730px" slogn="为了更健康的世界" subSlogn="For a healthier world"></carousel>
    <div class="box1">
      <div class="content">
        <div class="title">化学品安评专家</div>
        <div class="list">
          <div class="item">
            <img class="line1" src="@/assets/images/image110.png" alt="">
            <div class="line2">
              <div class="line2-left"><constantNum :setNumber="30" :duration="duration"></constantNum>%</div>
              <div class="line2-right">
                <div>+</div>
              </div>
            </div>
            <div class="line3">硕博人员占比</div>
          </div>
          <div class="item">
            <img class="line1" src="@/assets/images/image110.png" alt="">
            <div class="line2">
              <div class="line2-left"><constantNum :setNumber="7000" :duration="duration"></constantNum></div>
              <div class="line2-right">
                <div></div>
                <div>m²</div>
              </div>
            </div>
            <div class="line3">实验设施面积</div>
          </div>
          <div class="item">
            <img class="line1" src="@/assets/images/image110.png" alt="">
            <div class="line2">
              <div class="line2-left"><constantNum :setNumber="1000" :duration="duration"></constantNum></div>
              <div class="line2-right">
                <div class="textR">+</div>
                <div>台套</div>
              </div>
            </div>
            <div class="line3">各类实验设备数量</div>
          </div>
          <div class="item">
            <img class="line1" src="@/assets/images/image110.png" alt="">
            <div class="line2">
              <div class="line2-left"><constantNum :setNumber="500" :duration="duration"></constantNum></div>
              <div class="line2-right">
                <div class="textR">+</div>
                <div>家</div>
              </div>
            </div>
            <div class="line3">服务化学品企业</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="content">
        <div class="title">我们的服务</div>
        <!-- <div class="subTitle">核心及差异化优势，为您提供高品质的综合性科技服务</div> -->
        <div class="list">
          <div class="coreItem" @mouseenter="hoverEnterpriseIndex = 1" @mouseleave="hoverEnterpriseIndex = -1">
              <div class="core-mask" :class="hoverEnterpriseIndex==1?'core-mask-active':''">
              <div class="core-mask-title">农药登记试验</div>
              <div class="split"></div>
              <div class="detail">
                <p>核心团队深耕行业20年</p>
                <p>试验服务内容覆盖产品化学、</p>
                <p>毒理学、环境影响等领域</p>
              </div>
              <img class="more" src="@/assets/images/image177.png" @click="$router.push('/ourService/ourServicePesticide')">
            </div>
          </div>
          <div class="coreItem" @mouseenter="hoverEnterpriseIndex = 2" @mouseleave="(hoverEnterpriseIndex = -1)">
            <div class="core-mask" :class="hoverEnterpriseIndex==2?'core-mask-active':''">
              <div class="core-mask-title">新化学物质登记试验</div>
              <div class="split"></div>
              <div class="detail">
                <p>国内首批从事新化学物质登记试验单位</p>
                <p>试验内容覆盖</p>
                <p>物理化学性质、生态毒理、健康毒理三大领域</p>
              </div>
              <img class="more" src="@/assets/images/image177.png" @click="$router.push('/ourService/chemicalRegister')">
            </div>
          </div>
          <div class="coreItem" @mouseenter="hoverEnterpriseIndex = 3" @mouseleave="(hoverEnterpriseIndex = -1)">
            <div class="core-mask" :class="hoverEnterpriseIndex==3?'core-mask-active':''">
              <div class="core-mask-title">化妆品注册和备案检验</div>
              <div class="split"></div>
              <div class="detail">
                <p>资质覆盖</p>
                <p>理化、微生物、毒理学、人体功效</p>
                <p>全方位为客户提供一站式服务</p>
              </div>
              <img class="more" src="@/assets/images/image177.png" @click="$router.push('/ourService/makeUp')">
            </div>
          </div>
          <div class="coreItem" @mouseenter="hoverEnterpriseIndex = 4" @mouseleave="(hoverEnterpriseIndex = -1)">
            <div class="core-mask" :class="hoverEnterpriseIndex==4?'core-mask-active':''">
              <div class="core-mask-title">其他服务</div>
              <div class="split"></div>
              <div class="detail">
                <p>药物发现、化学品物理危险性鉴定与分类管理、</p>
                <p>农药产品质量检测、保健食品检验与评价、</p>
                <p>消毒产品检验等多领域服务</p>
              </div>
              <img class="more" src="@/assets/images/image177.png" @click="$router.push('/ourService/otherService')">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="banner">
        <div class="text">
          <div class="title">资质荣誉</div>
          <!-- <div class="subTitle">验证健安德检测的可持续发展能力</div> -->
        </div>
      </div>
      <div class="carousel-box">
        <!-- <div class="switch">
          <div :class="honorSwitch==1?'switch-active':'switch-default'" @click="honorSwitch = 1">公司资质</div>
          <div :class="honorSwitch!=1?'switch-active':'switch-default'" @click="honorSwitch = 2">企业荣誉</div>
        </div> -->
        <div class="swiper swiper-no-swiping" v-show="honorSwitch==1">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item,index) in honorList" :key="index">
                <div class="swiperItem" @mouseenter="hoverHonorIndex = index" @mouseleave="hoverHonorIndex = -1">
                    <div class="honorItem">
                      <img class="honorBg" @click="preview(index)" src="@/assets/images/image162.png" alt="">
                      <el-image 
                        class="honorImg"
                        style=""
                        :src="item.src[0]" 
                        fit="cover"
                        ref="honorList"
                        :preview-src-list="item.src">
                      </el-image>
                    </div>
                    <div class="mask mask1" v-show = "hoverHonorIndex==index">
                      <img src="@/assets/images/viewBigImg.png" alt="">
                    </div>
                </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
        <div class="swiper" v-show="honorSwitch!=1">
          <swiper :options="swiperOption2">
            <swiper-slide v-for="(item,index) in honorList2" :key="index">
                <div class="swiperItem" @mouseenter="hoverHonorIndex = index" @mouseleave="hoverHonorIndex = -1">
                    <el-image 
                      style="width: 400px; height: 282px"
                      :src="item.src" 
                      :preview-src-list="[item.src]">
                    </el-image>
                    <div class="mask mask2" v-show = "hoverHonorIndex==index">
                      <img src="@/assets/images/viewBigImg.png" alt="">
                    </div>
                </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>
    <div class="box4">
      <div class="title">健安德服务各行业化学品企业500余家</div>
      <div class="switch">
        <div :class="enterpriseSwitch==0?'switch-active':'switch-default'" @click="enterpriseSwiperChange(0)">农药领域</div>
        <div :class="enterpriseSwitch==1?'switch-active':'switch-default'" @click="enterpriseSwiperChange(1)">新化学物质领域</div>
        <!-- <div :class="enterpriseSwitch==2?'switch-active':'switch-default'" @click="enterpriseSwiperChange(2)">化妆品领域</div> -->
        <div :class="enterpriseSwitch==2?'switch-active':'switch-default'" @click="enterpriseSwiperChange(2)">其他领域</div>
      </div>
      <div class="swiper-box">
        <div class="swiper swiper2 swiper-no-swiping">
        <swiper :options="swiperOption3" class="enterpriseSwiper">
          <swiper-slide v-for="(item,index) in enterprise" :key="index">
              <div class="swiperItem">
                  <defaultImg class="enterpriseImg" :src="item.src"></defaultImg>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" :style="(enterpriseSwitch==0?{opacity:'.5'}:'')" slot="button-prev"></div>
          <div class="swiper-button-next" :style="(enterpriseSwitch==2?{opacity:'.5'}:'')" slot="button-next"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import carousel from "@/components/carousel/carousel"
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  const enterpriseSwiper = document.getElementsByClassName("enterpriseSwiper")
  export default {
    name: 'mainPage',
    components:{ carousel, swiper, swiperSlide },
    data () {
      return {
        duration:2000,
        topBanner:[
          {
            src: require("@/assets/images/image131.png")
          },
          {
            src: require("@/assets/images/image132.png")
          },
          {
            src: require("@/assets/images/image133.png")
          },
          {
            src: require("@/assets/images/image134.png")
          },
        ],
        honorList:[
          {
              title: "农药登记试验单位",
              src: [require("@/assets/images/honor/7.jpg")]
          },
          {
              title: "CNAS GLP良好实验室规范符合性证书",
              src: [require("@/assets/images/honor/2.jpg")]
          },
          {
              title: "CMA检验检测机构资质认定证书",
              src: [require("@/assets/images/honor/1.jpg")]
          },
          {
              title: "化妆品注册和备案检验机构",
              src: [require("@/assets/images/honor/6.jpg")]
          },
          // {
          //     title: "化学品测试机构",
          //     src: [require("@/assets/images/honor/5.jpg")]
          // },
          {
              title: "CNAS实验室认可证书",
              src: [require("@/assets/images/honor/3.jpg")]
          },
          // {
          //     title: "化学品物理危险性鉴定机构",
          //     src: [
          //         require("@/assets/images/honor/group3/1.jpg"),
          //         require("@/assets/images/honor/group3/2.jpg")]
          // },
          // {
          //     title: "管理体系认证证书",
          //     src: [
          //         require("@/assets/images/honor/group1/1.jpg"),
          //         require("@/assets/images/honor/group1/2.jpg"),
          //         require("@/assets/images/honor/group1/3.jpg")]
          // },
        //   {
        //       title: "知识产权管理体系认证证书",
        //       src: [require("@/assets/images/honor/10.jpg")]
        //   },
          // {
          //     title: "实验动物使用许可证",
          //     src: [require("@/assets/images/honor/9.jpg")]
          // },
          {
              title: "实验动物使用许可证（SPF）",
              src: [require("@/assets/images/honor/8.jpg")]
          },
          // {
          //     title: "贵州省病原微生物实验室BSL-2",
          //     src: [
          //         require("@/assets/images/honor/group2/1.jpg"),
          //         require("@/assets/images/honor/group2/2.jpg")]
          // },
        //   {
        //       title: "贵阳市检验检测与认证行业协会会员证书",
        //       src: [require("@/assets/images/honor/4.jpg")]
        //   },
          {
            title: "知识产权管理体系认证证书",
            src: [require("@/assets/images/honor/11.png")]
          },
        ],
        honorList2:[
          {
            src: require("@/assets/images/image14.png")
          },
          {
            src: require("@/assets/images/image14.png")
          },
          {
            src: require("@/assets/images/image14.png")
          },
          {
            src: require("@/assets/images/image14.png")
          },
          {
            src: require("@/assets/images/image14.png")
          },
          {
            src: require("@/assets/images/image14.png")
          },
        ],
        enterprise:[
          {
            src: require("@/assets/images/image165.png")
          },
          {
            src: require("@/assets/images/image166.png")
          },
          // {
          //   src: require("@/assets/images/image139.png")
          // },
          {
            src: require("@/assets/images/image167.png")
          },
        ],
        swiperOption: {
            slidesPerView:4,
            spaceBetween:60,
            speed: 2000,
            autoplay : {
                delay:2500,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            },
            // 设置点击箭头
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        },
        swiperOption2: {
            slidesPerView:3,
            spaceBetween:10,
            // 设置点击箭头
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        },
        swiperOption3: {
            slidesPerView:1,
            spaceBetween:10,
            // 设置点击箭头
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            on: {
                slideChange:() => {
                  this.enterpriseSwitch = enterpriseSwiper[0].swiper.activeIndex
                }
            }
        },
        honorSwitch: 1,
        hoverHonorIndex: -1,
        enterpriseSwitch: 0,
        hoverEnterpriseIndex: -1,
      }
    },
    methods: {
      preview(index){
        this.$refs.honorList[index].clickHandler();
      },
      enterpriseSwiperChange(index){
        enterpriseSwiper[0].swiper.slideTo(index)
      }
    },
    mounted(){
    }
  }
</script> 
  
<style lang='less' scoped>
  .box1{
    width: 100%;
    height: 410px;
    background-image: url("../../assets/images/temporary/image1.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    .content{
      width: 1440px;
      padding-top: 80px;
      margin: 0 auto;
      .title{
        font-size: 28px;
        font-weight: bold;
      }
      .list{
        display: flex;
        justify-content: space-between;
        margin-top: 80px;
        .item{
          .line1{
            display: block;
          }
          .line2{
            display: flex;
            .line2-left{
              color: #DB0000;
              font-size: 70px;
              font-weight: bold;
            }
            .line2-right{
              color: #DB0000;
              font-size: 20px;
              font-weight: bold;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              padding: 10px 0;
              .textR{
                text-align: right;
              }
            }
          }
          .line3{
            color: #3D3D3D;
            font-size: 18px;
          }
        }
      }
    }
  }
  .box2{
    width: 100%;
    background-color: #F2F2F2;
    padding-bottom: 80px;
    .content{
      width: 1440px;
      padding-top: 80px;
      margin: 0 auto;
      .title{
        font-size: 28px;
        font-weight: bold;
      }
      .subTitle{
        font-size: 16px;
        color: #DB0000;
        margin-top: 10px;
      }
      .list{
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        .coreItem:nth-child(1){
          background-image: url("../../assets/images/image135.png");
        }
        .coreItem:nth-child(2){
          background-image: url("../../assets/images/image136.png");
        }
        .coreItem:nth-child(3){
          background-image: url("../../assets/images/image137.png");
        }
        .coreItem:nth-child(4){
          background-image: url("../../assets/images/image138.png");
        }
        .coreItem{
          position: relative;
          z-index: 1;
          height: 560px;
          width: 350px;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
          overflow: hidden;
          .core-mask-active{
            margin-top: 280px !important;
          }
          .core-mask{
            margin-top: 495px;
            transition: .5s all ease;
            height: 280px;
            width: 350px;
            background-color: rgba(0, 0, 0, .7);
            z-index: 999;
            box-sizing: border-box;
            overflow: hidden;
            .core-mask-title{
              font-size: 26px;
              color: white;
              text-align: center;
              margin-top: 15px;
            }
            .split{
              margin: 0 auto;
              margin-top: 25px;
              height: 2px;
              width: 50px;
              background: #FFFFFF;
            }
            .detail{
              margin-top: 35px;
              color: white;
              font-size: 14px;
              text-align: center;
              width: 100%;
              line-height: 22px;
            }
            .more{
              cursor: pointer;
              height: 32px;
              width: 32px;
              margin: 0 auto;
              margin-top: 30px;
              display: block;
            }
          }
        }
      }
    }
  }
  .box3{
    position: relative;
    .banner{
      height: 300px;
      background-image: url("../../assets/images/image139.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      padding-top: 80px;
      box-sizing: border-box;
      .text{
        width: 1440px;
        margin: 0 auto;
        .title{
          font-size: 28px;
          font-weight: bold;
        }
        .subTitle{
          font-size: 16px;
          color: #DB0000;
          margin-top: 10px;
        }
      }
    }
    .carousel-box{
      width: 1440px;
      // height: 660px;
      padding-bottom: 80px;
      background-color: rgb(255, 255, 255);
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: -80px;
      border-radius: 18px;
      overflow: hidden;
    }
  }
  /deep/ .swiper2{
    .swiper-button-prev{
        border: 0;
        background: url("../../assets/images/carousel-white-left2.png") no-repeat center center !important;
    }
    .swiper-button-next{
        border: 0;
        background: url("../../assets/images/carousel-white-right2.png") no-repeat center center !important;
    }
  }
  /deep/ .swiper{
    margin-top: 60px;
    padding: 0 70px;
    display: flex;
    align-items: center;
    position: relative;
    .swiper-button-prev{
        border: 0;
        background: url("../../assets/images/carousel-red-left.png") no-repeat center center;
    }
    .swiper-button-next{
        border: 0;
        background: url("../../assets/images/carousel-red-right.png") no-repeat center center;
    }
    .swiperItem{
      position: relative;
      z-index: 1;
      .honorItem{
        position: relative;
        .honorBg{
          width: 282px; 
          height: 400px;
          cursor: pointer;
        }
        .honorImg{
          width: 262px; 
          height: 380px;
          position: absolute;
          z-index: -1;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }
      .mask{
        cursor: pointer;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, .5);
        position:absolute;
        left: 0;
        top: 0;
        z-index: 999;
      }
      .mask1{
        width: 282px; 
        height: 400px;
      }
      .mask2{
        width: 400px; 
        height: 282px;
      }
      .enterpriseImg{
        width: 1290px; 
        height: 400px;
      }
    }
  }
  .switch{
    display: flex;
    justify-content: center;
    margin-top: 60px;
    font-size: 17px;
    font-weight: bold;
    div{
      height: 40px;
      // width: 120px;
      padding: 0 25px;
      line-height: 40px;
      text-align: center;
      border-radius: 8px;
      cursor: pointer;
      margin-right: 30px;
      &:hover{
        background-color: #DB0000;
        color: white;
      }
    }
    .switch-active{
      background-color: #DB0000;
      color: white;
    }
    .switch-default{}
  }
  .box4{
    width: 100%;
    height: 750px;
    overflow: hidden;
    background-image: url("../../assets/images/image164.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    color: white;
    .title{
      font-size: 28px;
      font-weight: bold;
      margin-top: 80px;
      text-align: center;
    }
    .swiper-box{
      width: 1440px;
      // height: 660px;
      padding-bottom: 80px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 18px;
    }
  }
</style>